export enum CalendarTimetableEventBlockTypes {
  'LEZIONE' = 'LEZIONE',
  'RICEVIMENTO' = 'RICEVIMENTO',
  'DISPOSIZIONE' = 'DISPOSIZIONE',
  'SORVEGLIANZA' = 'SORVEGLIANZA',
  'SOSTITUZIONE' = 'SOSTITUZIONE',
  'GITA' = 'GITA',
}
